/**
 * Name: Edit Playlist Page
 * Author: @Gaurav
 * Date: 20-07-2021
 */
import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './EditPlaylistAndServer.scss';
import EditPlaylist from './EditPlaylist';
import EditPlaylistServer from './EditPlaylistServer';
import { LoaderSpinner } from '../../components';
import { Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import NavBar from '../../components/NavBarSearchSong';
import { CircularProgress } from '@mui/material';

// Images
import search from '../../assets/ic_search.png';
import Settings from '../../assets/Settings.png';
import Delete from '../../assets/Delete.png';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { songsStore } from '../../store';
import Popup from '../../components/Popup';
import RoundButton from '../../components/RoundButton';
import { playlistActions } from '../../actions';
import { _showAlert } from '../../utils';
import SearchBox from '../../components/SearchBox';

function EditPlaylistAndServer(props) {
  const history = useHistory();
  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [playlistName, setPlaylistName] = useState('');
  const [playlistType, setPlaylistType] = useState('');
  const [tabValue, setTabValue] = useState('playlist');
  const [deletePopUp, setDeletePopUp] = useState({
    isOpen: false,
    id: null,
  });
  const [searchInput, setSearchInput] = useState('');

  // Zustand Song Store
  const { songs, removeSong, setSongs } = songsStore((state) => {
    return {
      currSong: state.currSongToPlay,
      songs: state.songs,
      setSongs: state.setSongs,
      removeSong: state.removeSong,
    };
  });

  const handleRemoveSong = () => {
    removeSong(songs.find((item) => item.id === deletePopUp.id));
    setDeletePopUp({ isOpen: false, id: null });
  };

  const handleSaveSongs = () => {
    const songsIds = songs.map((item) => item.id);
    const playlistId = params?.playlistId;

    const updatePlaylist = async () => {
      setLoading(true);
      const response = await playlistActions.updatePlaylist(playlistId, { songs: songsIds });
      if (response.code === 'OK') {
        setLoading(false);
        _showAlert('Songs Added successfully', 4000);
        history.push(playlistType === 'UNLIMITED' ? `/unlimited-playlist/${params?.playlistId}` : `/radio-playlist/${params?.playlistId}`);
      }
    };

    updatePlaylist();
  };

  useEffect(() => {
    const fetchPlaylistById = async () => {
      const fetchPlaylistRes = await playlistActions.fetchPlaylistById(params?.playlistId);
      if (fetchPlaylistRes.code === 'OK') {
        const playlistData = fetchPlaylistRes?.data;
        const getSongs = playlistData?.songs;
        const getName = playlistData?.name;
        const getPlaylistType = playlistData?.type;
        setPlaylistName(getName);
        setSongs(getSongs);
        setPlaylistType(getPlaylistType);
      }
    };
    fetchPlaylistById();
  }, []);

  return (
    <>
      {/* {isLoading && <LoaderSpinner />} */}
      <NavBar
        data={playlistName}
        icon={Settings}
        currentRouteName={playlistName}
        breadcrumbsPath={[
          { name: 'Playlist' },
          playlistType === 'UNLIMITED'
            ? { name: 'Unlimited-playlist', link: '/unlimited-playlist' }
            : { name: 'Radio-playlist', link: '/radio-playlist' },
        ]}
      />
      <TabContext value={tabValue}>
        <div style={{ display: 'flex', alignItems: 'center', columnGap: 15, marginBlock: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', columnGap: 15 }}>
            <p>Edit:</p>
            <TabList
              onChange={(e, val) => {
                setTabValue(val);
                // setSearchInput('');
              }}
              aria-label="lab API tabs example"
              className="forplay-tab playlist-tabs"
              sx={{
                '& .MuiTabs-flexContainer': {
                  columnGap: '10px',
                },
                '& .MuiTab-root': {
                  fontFamily: 'Poppins',
                  fontWeight: '600',
                  fontSize: '12px',
                  lineHeight: '16px',
                  textTransform: 'capitalize',
                  paddingInline: '16px',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#6B3EB4',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#6B3EB4',
                },
              }}
            >
              <Tab value="playlist" label="Playlist" />
              <Tab value="server" label="Server" />
            </TabList>
          </div>
          <SearchBox onChange={(e) => setSearchInput(e)} />

          <RoundButton
            btnText={isLoading ? <CircularProgress sx={{ color: 'white', height: '25px !important', width: '25px !important' }} /> : 'Save'}
            style={{ marginLeft: 'auto' }}
            handleClick={handleSaveSongs}
          />
        </div>
        <div className="main_tbl_wrap">
          <TabPanel sx={{ padding: 0, overflow: 'hidden', flex: 1 }} value="playlist">
            <EditPlaylist searchInput={searchInput} />
          </TabPanel>
          <TabPanel sx={{ padding: 0, overflow: 'hidden', flex: 1 }} value="server">
            <EditPlaylistServer playlistType={playlistType} searchInput={searchInput} />
          </TabPanel>
          <TableContainer className="tbl_wraper  selectTbl edit-playlist-table" style={{ margin: 0 }} component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="result">Result</TableCell>
                  <TableCell style={{ minWidth: 170 }}>Selected Songs</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(songs) &&
                  songs.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell className="result">#{++index}</TableCell>
                      <TableCell className="table-name-cell">{row.title || row.fileName || row.name || 'N/A'}</TableCell>
                      <TableCell>
                        <img className="remove-icon" src={Delete} onClick={() => setDeletePopUp({ isOpen: true, id: row.id })} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </TabContext>

      <Popup open={deletePopUp?.isOpen} onClose={() => setDeletePopUp({ isOpen: false, id: null })}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to delete this Song?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <button onClick={() => setDeletePopUp({ isOpen: false, id: null })} className="button transparent">
            Cancel
          </button>
          <button onClick={handleRemoveSong} className="button primary">
            Confirm
          </button>
        </div>
      </Popup>
    </>
  );
}

export default EditPlaylistAndServer;

